import { memo, useEffect, useState } from "react";
import Adjustment2TablesWrapper from "./AdjustmentTablesWrapper";
import Adjustment2Config from "./AdjustmentConfig";
import Modal from "../../../Components/Modal/Modal";
import Button from "../../../Components/Button";
import { IAdjustment2SearchParam } from "../../../Interfaces/deltaHedgeAdjustment";
import SelectableButtons from "../../../Components/Dropdown/SelectableButtons";
import { DropdownItem } from "../../../Interfaces/dropdownInterfaces";
import { getGroups } from "../../../Requests/optionDomain";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import ReferenceConfig from "./ReferenceConfig";
import ReferenceTable from "../../../Tables/OptionDomain/Adjustment2/ReferenceTable";

enum ModalMode {
  Closed,
  Adjustment,
  Reference,
}

const Adjustment = memo(() => {
  const [modalMode, setModalMode] = useState(ModalMode.Closed);
  const [searchParams, setSearchParam] = useState(
    {} as IAdjustment2SearchParam
  );

  const [groups, setGroups] = useState([] as DropdownItem[]);

  useEffect(() => {
    getGroups()
      .then((resp) => {
        setGroups(resp);
        setSearchParam({ groupId: resp[0].id } as IAdjustment2SearchParam);
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: any) => {
    setSearchParam({ ...searchParams, [name]: value });
  };

  const getModalUI = () => {
    switch (modalMode) {
      case ModalMode.Adjustment:
        return (
          <Adjustment2Config onClose={() => setModalMode(ModalMode.Closed)} />
        );

      case ModalMode.Reference:
        return (
          <ReferenceConfig
            onClose={() => setModalMode(ModalMode.Closed)}
            groupId={searchParams.groupId}
          />
        );

      default:
        return <></>;
    }
  };

  return (
    <div className="w-full flex flex-col justify-start items-start gap-5">
      {modalMode !== ModalMode.Closed ? (
        <Modal
          UI={getModalUI()}
          onClose={() => setModalMode(ModalMode.Closed)}
          fullScreen={modalMode === ModalMode.Adjustment}
        />
      ) : (
        <></>
      )}
      <div className="flex flex-row justify-start items-end gap-8 w-full">
        <div className="flex flex-col justify-start items-start gap-3">
          <div className="flex flex-row justify-start items-end gap-3">
            <div className="w-56">
              <Button
                text="تنطیمات تعدیل"
                variant="outlined"
                onClick={() => setModalMode(ModalMode.Adjustment)}
              />
            </div>
            <div className="w-56">
              <Button
                text="تنظیمات مرجع"
                variant="outlined"
                onClick={() => setModalMode(ModalMode.Reference)}
              />
            </div>
          </div>
          <SelectableButtons
            label="گروه"
            name="groupId"
            options={groups}
            onChange={changeHandler}
            value={searchParams.groupId?.toString()}
            hideSelectAll
            hideLabel
          />
        </div>
        {searchParams.groupId ? (
          <div className="w-min">
            <ReferenceTable searchParams={searchParams} />
          </div>
        ) : (
          <></>
        )}
      </div>
      {searchParams.groupId ? (
        <Adjustment2TablesWrapper searchParams={searchParams} />
      ) : (
        <></>
      )}
    </div>
  );
});

export default Adjustment;
